import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { Process } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProcessService extends TmsWebBaseEditService<Process, Process> {
  constructor() {
    super('Process', $localize`Process`);
  }
}
